import { inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import * as fromAddressesStore from '../../addresses/store';
import { combineLatest, of } from 'rxjs';
import { CanActivateFn } from '@angular/router';

export const NearestGripLocationGuard: CanActivateFn = route => {
  const store = inject(Store);

  return combineLatest([store.select(fromStore.getNearestGripLocationLoaded), store.select(fromStore.getNearestGripLocationLoading)])
    .pipe(
      withLatestFrom(store.select(fromAddressesStore.getAddress), store.select(fromStore.getNotificationToken)),
      tap(([[loaded, loading], address, token]) => {
        if (!loaded && !loading && address) {
          store.dispatch(
            fromStore.LoadNearestGripLocation({
              postalCode: `${address.postalCodeFull}`,
              houseNumber: +address.houseNumber,
              addition: address.addition,
              token,
            })
          );
        }
      }),
      filter(([[loaded, loading], address]) => loaded && !loading),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
